import * as uuid from 'uuid'

import { Button, Divider } from '@/shared'
import { type IRuleSection, type IServiceRulesWrapper } from '@App/types/servicesTypes'

import style from './Buttons.module.scss'

interface IProps {
    isFetching: boolean
    code: string
    title: string
    description: string
    sections: IRuleSection[]
    isValidFields: boolean
    onChangeRules: (dto: IServiceRulesWrapper, onSuccess?: () => void, withFetching?: boolean) => void
}

export const Buttons = (props: IProps) => {
    const { isFetching, code, title, description, sections, isValidFields, onChangeRules } = props
    const onAddRuleHandler = () => {
        const dto: IServiceRulesWrapper = {
            code,
            sections: [{ id: uuid.v4(), title, description }]
        }
        onChangeRules(dto)
    }
    const onRemoveAllRules = () => onChangeRules({ code, sections: [] })

    const saveButtonTitle = sections.length > 0 ? 'Изменить' : 'Добавить'

    return (
        <div className={style.container}>
            <div className={style.divider}>
                <Divider />
            </div>
            <div className={style.wrapper}>
                <div className={style.btnWrapper}>
                    <Button onClick={onAddRuleHandler} disabled={isValidFields}>
                        {saveButtonTitle}
                    </Button>
                </div>
                {sections.length > 0 && (
                    <div className={style.btnWrapper}>
                        <Button onClick={onRemoveAllRules} disabled={isFetching}>
                            Удалить
                        </Button>
                    </div>
                )}
            </div>
        </div>
    )
}
